import {
  Box,
  Typography,
  IconButton,
  Modal,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PopupModal = ({ name, percentage, open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="popup-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          //maxWidth: "700px",
          width: "80%",
          height: "80%",
          backgroundColor: "#EAE6DA", // Popup background color
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
          borderRadius: "20px",
          padding: "2rem",
          border: "2px solid #492A18", // Border color
          overflowY: "scroll",
        }}
      >
        <style>
          {`
            ::-webkit-scrollbar {
              width: 8px; /* Scrollbar width */
            }
            ::-webkit-scrollbar-thumb {
              background-color: #492A18; /* Scrollbar thumb color */
              border-radius: 4px; /* Round edges */
            }
            ::-webkit-scrollbar-thumb:hover {
              background-color: #65412C; /* Darker color on hover */
            }
            ::-webkit-scrollbar-track {
              background-color: #EAE6DA; /* Track background matching popup */
            }
          `}
        </style>
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "16px",
            right: "16px",
            color: "#492A18",
            width: "30px",
            height: "30px",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title Section */}
        <Typography
          id="popup-title"
          variant="h5"
          component="h2"
          sx={{
            fontWeight: "400",
            textAlign: "left",
            marginBottom: "1.5rem",
            color: "#492A18",
            fontFamily: "Cinzel",
            fontSize: "40px",
          }}
        >
          Hypnotherapy Has Been Proven to Be{" "}
          <span
            style={{
              color: "#492A18",
              fontFamily: "Cinzel-Bold",
              fontSize: "40px",
            }}
          >
            Highly Effective for Multiple Conditions, Including
          </span>{" "}
        </Typography>

        {/* Main Content */}
        <Typography
          variant="h6"
          component="h3"
          sx={{
            fontWeight: "bold",
            textAlign: "left",
            marginBottom: "1rem",
            color: "#492A18",
            fontFamily: "Cinzel-Bold",
            fontSize: "55px",
          }}
        >
          {name} – {percentage}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "justify",
            marginBottom: "1.5rem",
            color: "#492A18",
            fontSize: "28px",
            lineHeight: "1.6",
            fontFamily: "Calibri",
          }}
        >
          A 2019 meta-analysis published in the International Journal of
          Clinical and Experimental Hypnosis evaluated the effectiveness of
          hypnosis in treating anxiety. The study found that participants
          receiving hypnosis experienced a significant reduction in anxiety
          symptoms, outperforming approximately 79% of individuals in control
          groups who did not receive hypnosis interventions.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            wordBreak: "break-word",
            marginBottom: "1rem",
            color: "#492A18",
            fontSize: "28px",
            textDecoration: "underline",
            fontFamily: "Calibri",
          }}
        >
          <a
            href="https://underfund.dk/wp-content/uploads/2020/03/The-Efficacy-of-Hypnosis-as-a-Treatment-for-Anxiety-A-Meta-Analysis.pdf?utm_source=chatgpt.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://underfund.dk/wp-content/uploads/2020/03/The-Efficacy-of-Hypnosis-as-a-Treatment-for-Anxiety-A-Meta-Analysis.pdf?utm_source=chatgpt.com
          </a>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "justify",
            marginBottom: "2rem",
            lineHeight: "1.6",
            color: "#492A18",
            fontSize: "28px",
            fontFamily: "Calibri",
          }}
        >
          This substantial effect suggests that hypnotherapy can be a highly
          effective treatment option for anxiety, providing greater relief than
          standard care or no treatment in many cases. It's important to note
          that the effectiveness of hypnotherapy can vary based on individual
          factors and the specific nature of the anxiety being treated.
        </Typography>

        {/* Additional Research Section */}
        <Typography
          variant="h6"
          sx={{
            textAlign: "left",
            color: "#492A18",
            fontSize: "22px",
            fontFamily: "Calibri",
            marginBottom: "1rem",
          }}
        >
          Additional Research
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          {[
            { label: "94%", title: "Efficacy and Need for Hypnosis" },
            { label: "93%", title: "Headaches and Migraines" },
            { label: "80%", title: "Pain Management" },
            { label: "76%", title: "Depression" },
            { label: "76%", title: "Pediatrics" },
          ].map((item, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                padding: "1rem",
                borderRadius: "20px",
                textAlign: "center",
                flex: "1 1 120px",
                backgroundColor: "#EAE6DA",
                border: "1px solid #492A18",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "#492A18",
                }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.85rem",
                  color: "#555",
                }}
              >
                {item.title}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default PopupModal;
